import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Step from './Step';

import styles from './index.scss';

class Stepper extends Component {
    render() {
        const { steps, activeStep } = this.props;
        return (
            <div className={styles.Stepper}>
                {steps.map((step, index) => (
                    <Step title={step.title} key={index} activeStep={index + 1 === activeStep} count={index + 1} />
                ))}
            </div>
        );
    }
}

Stepper.propTypes = {
    activeStep: PropTypes.number.isRequired,
    steps: PropTypes.array.isRequired,
};

Stepper.defaultProps = {
    activeStep: '',
    steps: '',
};

export default Stepper;
